import apiFetch from '../../apiFetch'

export default function (vehicleData, saleType, dossierId, token) {
  return apiFetch({ endPoint: 'Dossier/DossierStockorderQuiter?saleType=' + saleType + '&dossierId=' + dossierId, method: 'POST', body: vehicleData, token: token })
}
